import Button from '@bugbug/core/components/Button';
import Icon from '@bugbug/core/components/Icon';
import styled, { createGlobalStyle } from 'styled-components';

import { Backdrop } from '~/components/modals';

export const Container = styled.div`
  width: 590px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 10px 35px 25px 35px;
`;

export const BackdropOverrides = createGlobalStyle`
  ${Backdrop} {
    padding-top: 8vh;
  }
`;

export const Subtitle = styled.p`
  font-size: 15px;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding-top: 8px;
  padding-bottom: 26px;
`;

export const FeaturesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  width: 100%;
  gap: 20px;
`;

export const FeaturesContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
  border: 2px solid ${({ theme }) => theme.colors.border.semi};
  border-radius: 8px;
  gap: 14px;
`;

export const FeaturesListTitle = styled.p`
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  margin: 0;
`;

export const FeaturesList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
`;

export const FeatureListItem = styled.li`
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  align-items: center;
`;

export const GreenCheckIcon = styled(Icon).attrs({
  name: 'check',
  width: 20,
  height: 20,
})`
  color: ${({ theme }) => theme.colors.status.success};
  margin: 2px;
`;

export const RedCancelIcon = styled(Icon).attrs({
  name: 'close',
  width: 10,
  height: 10,
})`
  color: ${({ theme }) => theme.colors.status.failure};
  margin: 7px;
`;

export const PremiumFeaturesInfo = styled.p`
  font-size: 12px;
  line-height: 1.33;
  margin: 0;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin-bottom: 12px;
`;

export const ChoiceButton = styled(Button)`
  margin-top: auto;
  div {
    justify-content: center;
  }
`;

export const BrandsInfo = styled.p`
  margin-top: 40px;
  margin-bottom: 6px;
`;
